












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine';
import {  groupByNumber } from '@/utils/groupBy';
import { getImageUrl } from '@/utils/images';
import { AloTemplateCours, getDefaultAloTemplateCours } from '@/models/alo/AloTemplateCours';

@Component({
  name: 'ReadTemplateCours',    
   props: {
    tc:{      
      type:Object,
      default:getDefaultAloTemplateCours()
    }
  }
})
export default class ReadTemplateCours extends Vue {
  private tc!:AloTemplateCours
  private loading!:boolean

  get imageUrl(){
    return getImageUrl(this.activite?.image)
  }

  get activite(){
    return this.activityDic[this.tc.acyId] 
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get configuration(){    
    return this.$store.myGetters.configuration
  }

  get joursCours() {
    return groupByNumber(this.tc.horaires,t=>t.thrJour)
  }
}
